import { render, staticRenderFns } from "./SendMessageOtherUserHistory.vue?vue&type=template&id=c3773286&scoped=true&lang=pug"
import script from "./SendMessageOtherUserHistory.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserHistory.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageOtherUserHistory.vue?vue&type=style&index=0&id=c3773286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3773286",
  null
  
)

export default component.exports